import cookie from 'react-cookies';

import TenantConfig from '../config';

export const isPrimaryApplicant = (app) => {
  const applicantFeature = app.applicationFeatures?.find(
    (item) => item.itemType === 'ApplicantProperty'
  );

  // for non-primary owners, we don't send email field for other users.
  return (
    applicantFeature?.value == null ||
    applicantFeature?.value?.length == 1 ||
    !!applicantFeature?.value[0]?.email
  );
};

export const isInitialSubmit = (app) => {
  if (app?.status === 'PRE_SUBMISSION') {
    return true;
  } else {
    const applicantProp = app?.applicationFeatures?.find(
      (feature) => feature.itemType === 'ApplicantProperty'
    );
    return applicantProp && applicantProp.phase === app?.phase;
  }
};

export const isProductALoan = (product) => {
  return (
    !product.productCode.includes('GRANT') &&
    !product.productCode.includes('BHCIP') &&
    !product.productCode.includes('CA_PERFORMING_ARTS') &&
    !product.productCode.includes('CA_DREAM_FUND') &&
    !product.productCode.includes('LA_COUNTY_EOG_MCRGP') &&
    !product.productCode.includes('LA_COUNTY_ARP_FPO_001') &&
    !product.productCode.includes('LA_COUNTY_ARP_NPO_001')
  );
};

/** Check if the property is contained in the section */
export const isPropertyInSection = (features, section, property) => {
  const feature = features.find((feature) => feature.name === property);
  if (!feature) {
    return false;
  }
  return feature.section === section;
};

export const cleanUpSessionData = () => {
  const appId = cookie.load(`appId`);
  cookie.remove('lendistry_tokens_access', { path: '/' });
  cookie.remove('lendistry_tokens_refresh', { path: '/' });
  cookie.remove(`${appId}_may_qualify_visited`);
  cookie.remove('appId', { path: '/' });
  localStorage.clear();
};

export const getApplicationId = (app, truncated) => {
  if (TenantConfig?.general?.useAccountId === true && app.accountId) {
    return app.accountId.toUpperCase();
  } else {
    if (truncated) return app.id.substring(app.id.length - 4);
    else {
      return app.id;
    }
  }
};
